import { render, staticRenderFns } from "./DormUserDormDetail.vue?vue&type=template&id=cb5f98b8&"
import script from "./DormUserDormDetail.vue?vue&type=script&lang=js&"
export * from "./DormUserDormDetail.vue?vue&type=script&lang=js&"
import style0 from "./DormUserDormDetail.vue?vue&type=style&index=0&id=cb5f98b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports